export default __webpack_public_path__ + "static/media/vid-04.cfd26039.mp4";